import {BrandImage} from "../../components/brandImage";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { setComponentActive, setUserLogOut } from "../../reducers/userConfigSlice";
import { MdLightMode, MdModeNight } from "react-icons/md";
import { IoCloseOutline, IoMenuOutline } from "react-icons/io5";

import "./style.css";
import { PiPackage } from "react-icons/pi";
import { LuAppWindowMac, LuHistory } from "react-icons/lu";
import { HiOutlineCog6Tooth } from "react-icons/hi2";
import { RiLogoutBoxRLine } from "react-icons/ri";

export const Menu = () => {
  const [menuActive, setMenuActive] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem("kitchen-theme") || "light");
  const logo = useSelector(
    (state) =>
      state.aplicationConfig.corporationData.info?.logo
  );
  const dispatch = useDispatch();

  const componentActive = useSelector(
    (state) => state.aplicationConfig.userConfig.componentActive
  );

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("kitchen-theme", theme);
  }, [theme]);

  const handleTheme = (newTheme) => {
    setTheme(newTheme);
  };

  const logOff = async () => {
    dispatch(setUserLogOut());
    const selectedTheme = localStorage.getItem("kitchen-theme");
    localStorage.clear();
    sessionStorage.clear();
    if (selectedTheme) localStorage.setItem("kitchen-theme", selectedTheme);
    setMenuActive(!menuActive);
  };

  const handleMenu = (component) => {
    dispatch(setComponentActive(component));
    setMenuActive(!menuActive);
  };

  const FloatMenu = () => {
    return (
      <>
        <div
          className="menu-close"
          aria-label="Cerrar menú"
          onClick={() => setMenuActive(!menuActive)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              setMenuActive(!menuActive);
            }
          }}
        >
          <IoCloseOutline />
        </div>
        <div className="floatMenu">
          <div className="menu-top">
            <div className="menu-logo">
              <BrandImage
                alt="logo-bussiness"
                src={logo}
              />
            </div>

            <div className="menu-list">
              <div
                className={
                  componentActive === "kd" ? "menu-item selected" : "menu-item"
                }
                onClick={() => handleMenu("kd")}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleMenu("kd");
                  }
                }}
              >
                <PiPackage size={"40px"} /> Gestor de pedidos
              </div>
              <div
                className={
                  componentActive === "listdisplay"
                    ? "menu-item selected"
                    : "menu-item"
                }
                onClick={() => handleMenu("listdisplay")}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleMenu("listdisplay");
                  }
                }}
              >
                <LuHistory size={"40px"} /> Historial de pedidos
              </div>
              <div
                className={
                  componentActive === "readyOrders"
                    ? "menu-item selected"
                    : "menu-item"
                }
                onClick={() => handleMenu("readyOrders")}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleMenu("readyOrders");
                  }
                }}
              >
                <LuAppWindowMac size={"40px"} /> Pedidos listos
              </div>
              <div
                className={
                  componentActive === "settings"
                    ? "menu-item selected"
                    : "menu-item"
                }
                onClick={() => handleMenu("settings")}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleMenu("settings");
                  }
                }}
              >
                <HiOutlineCog6Tooth size={"40px"} /> Configuración
              </div>
              <div
                className="menu-item"
                onClick={logOff}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    logOff();
                  }
                }}
              >
                <RiLogoutBoxRLine color={"var(--color-error)"} size={"40px"} />{" "}
                Salir
              </div>
            </div>
          </div>

          <div className="menu-bottom">
            <div className="kitchen-mode" aria-label="Modo de visualización">
              <button
                type="button"
                className={`kitchen-mode-button ${theme === "light" ? "selected" : ""}`}
                onClick={() => handleTheme("light")}
                aria-label="Activar modo día"
                aria-pressed={theme === "light"}
              >
                <MdLightMode />
              </button>
              <button
                type="button"
                className={`kitchen-mode-button ${theme === "dark" ? "selected" : ""}`}
                onClick={() => handleTheme("dark")}
                aria-label="Activar modo noche"
                aria-pressed={theme === "dark"}
              >
                <MdModeNight />
              </button>
            </div>

            <div className="kitchen-guide">
              <div className="kitchen-guide-title">Estados del producto</div>
              <div className="kitchen-guide-state">
                <div className="circle-state circle-white"></div>
                <div>Pendiente por preparar</div>
              </div>
              <div className="kitchen-guide-state">
                <div className="circle-state circle-preparation"></div>
                <div>En preparación</div>
              </div>
              <div className="kitchen-guide-state">
                <div className="circle-state circle-prepared"></div>
                <div>Preparado</div>
              </div>
            </div>
          </div>
        </div>
        <div className="background-shadow"></div>
      </>
    );
  };

  const ActiveButtonMenu = () => {
    return (
      <button
        className="activeButtonMenu"
        onClick={() => setMenuActive(!menuActive)}
        type="button"
        aria-label="Abrir menú"
      >
        <div>
          <IoMenuOutline />
        </div>
        <div>Menu</div>
      </button>
    );
  };

  return !menuActive ? <ActiveButtonMenu /> : <FloatMenu />;
};
